import { zipObject } from 'es-toolkit';

import originLocationFilter from '../filters/originLocation';

export default class OriginLocation {

    static WAD = 'WAD';
    static OS = 'OS';
    static GERMANY = 'GERMANY';
    static IRELAND = 'IRELAND';

    static options(): Record<string, string | null> {

        const keys = Object.keys(OriginLocation);

        return zipObject(keys, keys.map(key => originLocationFilter(key)));
    }
}
